import React from 'react';
import { dateToString } from 'services/utils/date';

const Date = ({ date }) => <td>{date ? dateToString(date) : '-'}</td>;

export default Date;
